import logEvent from "../tracking/amplitude/log-event"
import { getSlideshowViewEventOptions } from "../tracking/amplitude/log-slideshow-events"
import { isMobile } from "../utils/breakpoints"
import { goToSlide, hideMobileNavigation } from "./player-navigation"
import store from "./player-store"
import { isInfographic, isEmbed } from "./presentation-types"
import { handleShareToggleOpen } from "./share"
import { player } from "./selectors"
import fullscreenAPI from "../utils/fullscreen-api"

const nextSlideshowContainer = $("#new-player .next-container")
const nextSlideshowCancel = $("#new-player .j-next-cancel")
const nextSlideshowTimer = $("#new-player .j-timer-count")
const nextButton = $("#new-player .next-slideshow-responsive")
const embedLastScreen = $("#new-player #lastScreen")
const embedLastScreenOverlay = embedLastScreen.find(".j-last-screen-overlay")
const embedLastScreenEmailButton = embedLastScreen.find(".j-email-cta")
const embedLastScreenShareButton = embedLastScreen.find(".j-share-cta")
const embedLastScreenReplayButton = embedLastScreen.find(".j-last-screen-replay")
const embedLastScreenCloseButton = embedLastScreen.find(".j-lastscreen-close")

let countdownInterval = null

const goToNextSlideshow = (nextSlideshow) => {
  logEvent("next_slideshare", getSlideshowViewEventOptions())

  const redirectUrl = window.location.origin + nextSlideshow.url + "?next_slideshow=" + nextSlideshow.id

  window.location.href = redirectUrl
}

const showNextSlideshowScreen = () => {
  const nextSlideshow = {
    id: nextSlideshowContainer.data("next-slideshare-id") || 0,
    thumb: nextSlideshowContainer.data("next-slideshare-thumb") || "",
    title: nextSlideshowContainer.data("next-slideshare-title") || "",
    url: nextSlideshowContainer.data("next-slideshare-url") || "#",
  }
  let remainingSeconds = 2
  nextSlideshowTimer.text(remainingSeconds + 1)

  const countDown = () => {
    if (remainingSeconds === 0) {
      clearInterval(countdownInterval)
      goToNextSlideshow(nextSlideshow)
    }

    if (remainingSeconds >= 0) {
      nextSlideshowTimer.text(remainingSeconds)
      remainingSeconds--
    }
  }
  countdownInterval = setInterval(countDown, 1000)

  nextSlideshowContainer.addClass("active")
}

const toggleNextSlideshowScreen = (shouldShow) => {
  if (shouldShow) {
    showNextSlideshowScreen()
  } else {
    clearInterval(countdownInterval)
    store.endDisplay.isActive = false
    nextSlideshowContainer.removeClass("active")
  }
}

const toggleNextButton = (shouldShow) => {
  if (shouldShow) {
    logEvent("next_slideshare_button", getSlideshowViewEventOptions())
    nextButton.addClass("active")
  } else {
    store.endDisplay.isActive = false
    nextButton.removeClass("active")
  }
}

const toggleEmbedLastScreen = (shouldShow) => {
  if (shouldShow) {
    embedLastScreen.find("img.j-thumbnail").trigger("loadThumb")
    embedLastScreen.addClass("lastScreenContainer")
    populateEmbedSizes()
    embedLastScreen.css({ display: "flex" })
  } else {
    store.endDisplay.isActive = false
    embedLastScreen.css({ display: "none" })
  }
}

const populateEmbedSizes = () => {
  let embedSizesPicker = embedLastScreen.find(".j-embed-size-picker")
  $.each(store.embedPlayer.embedSizes.presets, function (key, value) {
    let displayWidth = value.size.width + 4
    let displayHeight = value.size.height + 2

    let option = $("<option/>")
      .val(key)
      .text(displayWidth + "x" + displayHeight)
    embedSizesPicker.append(option)
  })
  embedSizesPicker.val(store.embedPlayer.embedSizes.config.defaultPreset).change()
}

const hideStageDownloadCTA = () => {
  $(".stage-download-cta").hide()
}

const showStageDownloadCTA = () => {
  $(".stage-download-cta").show()
}

const getDisplayType = () => {
  if (isEmbed()) {
    return "embed_lastScreen" // embed player
  } else if (isMobile()) {
    return "next_button" // mobile
  } else {
    return "next_slideshow" // desktop
  }
}

const toggleDisplay = (type, shouldShow) => {
  switch (type) {
    case "next_button": // mobile
      toggleNextButton(shouldShow)
      break
    case "next_slideshow": // desktop
      toggleNextSlideshowScreen(shouldShow)
      break
    case "embed_lastScreen": // embed player last screen
      toggleEmbedLastScreen(shouldShow)
      break
  }
}

export const showEndDisplay = () => {
  const shouldBlurReader = player.attr("data-shouldblurreader")
  const isUploadPreview = $("body").hasClass("upload-preview")
  if (isUploadPreview || isInfographic() || store.isLoading) {
    return
  }
  store.endDisplay.isActive = true
  hideStageDownloadCTA()
  hideMobileNavigation()
  /**
   * Do not show next slideshow when view restriction is on
   */
  if (!shouldBlurReader) {
    toggleDisplay(getDisplayType(), true)
  }
}

export const hideEndDisplay = () => {
  if (isInfographic() || store.isLoading) {
    return
  }

  clearInterval(countdownInterval)
  store.endDisplay.isActive = false

  if (!fullscreenAPI.isFullscreen) {
    showStageDownloadCTA()
  }

  toggleDisplay(getDisplayType(), false)
}

const addToStore = (config) => {
  store.endDisplay = {
    isActive: false,
  }

  store.embedPlayer = {
    embedSizes: config.embed_sizes,
    embedCode: config.embed_code,
    wpCode: config.wp_code,
  }
}

export const initializeEndDisplay = (config) => {
  addToStore(config)

  embedLastScreen.find("img.j-thumbnail").lazyload({
    effect: "fadeIn",
    event: "loadThumb",
  })

  embedLastScreenOverlay.on("click", () => {
    toggleEmbedLastScreen(false)
  })

  embedLastScreenCloseButton.on("click", () => {
    toggleEmbedLastScreen(false)
  })

  embedLastScreenEmailButton.on("click", handleShareToggleOpen)

  embedLastScreenShareButton.on("click", handleShareToggleOpen)

  embedLastScreenReplayButton.on("click", () => {
    toggleEmbedLastScreen(false)
    goToSlide(0)
  })

  nextSlideshowCancel.on("click", function () {
    toggleNextSlideshowScreen(false)
  })
}
